import React, { forwardRef } from 'react';
import type { AccordionProps } from '@mui/material';
import { Accordion as AccordionMUI } from '@mui/material';

import { omitUndefinedProps } from '@/mui/helpers';

import { CUSTOM_ATTRIBUTE_FULL_WIDTH } from './Accordion.api';

type Props = {
  fullWidth?: boolean;
};

const Accordion = forwardRef<HTMLDivElement, AccordionProps & Props>(({ children, ...props }, ref) => (
  <AccordionMUI
    {...omitUndefinedProps({
      ...props,
      fullWidth: undefined,
      [CUSTOM_ATTRIBUTE_FULL_WIDTH]: props.fullWidth ? '' : undefined,
    })}
    ref={ref}
  >
    {children}
  </AccordionMUI>
));

Accordion.displayName = 'Accordion';

export default Accordion;
